import css from './OrderCard.module.scss';
import moment from 'moment';
import { formatOrderType } from 'src/utils/designUtils';
import OrderStatusChangerSimple from '../organisms/OrderStatusChangerSimple';

export default function OrderCard(props) {
  const { handleDetails, handleCancel, ...order } = props;

  return (
    <>
      <div className={css['card']} onClick={() => handleDetails(order._id)}>
        <p className={css['name']}>#{order.orderRef}</p>

        {/* <OrderStatusChanger
          order={order}
          updateOrder={(status, id) => updateOrder(status, id)}
          cancelOrder={handleCancel}
          view="card"
        /> */}

        <OrderStatusChangerSimple
          order={order}
          handleCancel={handleCancel}
        />

        <p className={css['price']}>${order.merchantShare.toFixed(2)}</p>
        <p className={css['time']}>
          {moment(order.orderDate).format('D MMM HH:mm')}, {formatOrderType(order.orderType).text}
        </p>
      </div>
    </>
  );
}
